import React from 'react';
import { formatNumber, CURRENCY } from '../../utils/format';

/**
 * Montant : chiffres tabulaires, jamais coupé sur deux lignes, unité en
 * micro-libellé capitales. `align="end"` pour les colonnes de tableau, où les
 * montants doivent s'aligner sur leur chiffre des unités.
 */
const Amount = ({ value, currency = CURRENCY, align = 'start', strong = true, className = '' }) => (
  <span
    className={`amount inline-flex items-baseline gap-1 whitespace-nowrap tabular-nums ${
      align === 'end' ? 'justify-end text-end' : ''
    } ${strong ? 'font-semibold' : 'font-medium'} text-ink ${className}`}
  >
    <bdi>{formatNumber(value)}</bdi>
    <span className="unit text-2xs font-semibold uppercase text-ink-subtle">{currency}</span>
  </span>
);

export default Amount;
